"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("./form-content/component");
const component_2 = require("@front/components/site-menu/component");
component_1.KnowledgeFormContent;
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="container-fluid">
    <div class="knowledge-form-page">
      <div class="row">
        <div class="col-lg-8 col-12 pb-lg-5">
          <div class="mb-2">
            <h1>${x => x.knowledgeId ? 'knowledge.form.title.edit'.t() : 'knowledge.form.title.add'.t()}</h1>
            <div class="text-zero top-right-button-container">
              <button @click="${(x, c) => x.back.bind(x)()}" type="button"
                class="top-right-button mr-1 btn btn-primary btn-lg">${'knowledge.form.back'.t()}</button>
            </div>
          </div>
          <div class="card card-body mb-5">
            <knowledge-form-content :routeParams="${x => x.routeParams}"></knowledge-form-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let KnowledgeForm = class KnowledgeForm extends client_1.RWSViewComponent {
    back() {
        component_2.SiteMenu.goto.bind(this)('/ai/knowledge/list');
    }
};
exports.KnowledgeForm = KnowledgeForm;
exports.KnowledgeForm = KnowledgeForm = __decorate([
    (0, client_1.RWSView)('knowledge-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], KnowledgeForm);
KnowledgeForm.defineComponent();
